import { render, staticRenderFns } from "./cModalEpicrisis.vue?vue&type=template&id=06de1d83"
import script from "./cModalEpicrisis.vue?vue&type=script&lang=js"
export * from "./cModalEpicrisis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports